import Head from 'next/head';
import React from 'react';

export type GoogleTagManagerVariablesHeadScriptProps = {
  content: string;
};
const GoogleTagManagerVariablesHeadScript = ({
  content,
}: GoogleTagManagerVariablesHeadScriptProps) => {
  return (
    <Head>
      <script
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: `${content}
          `,
        }}
      />
    </Head>
  );
};

export default GoogleTagManagerVariablesHeadScript;
